import React from 'react'
import {Alert, Button, Snackbar, Typography, Box} from '@mui/material'
import {styled} from '@mui/material/styles'
import {Clock, X} from 'lucide-react'
import {useSessionTimeout} from '~/src/context/SessionTimeoutContext'

const StyledAlert = styled(Alert)(({theme}) => ({
  minWidth: '400px',
  maxWidth: '500px',
  padding: theme.spacing(2),
  alignItems: 'flex-start',
  '& .MuiAlert-icon': {
    marginTop: '2px',
  },
  '& .MuiAlert-message': {
    width: '100%',
  },
  '& .MuiAlert-action': {
    paddingTop: 0,
    marginRight: 0,
  },
}))

const MessageContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
})

const TitleRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
})

// TODO: Re-enable when BE refresh endpoint is available
// const ActionContainer = styled(Box)(({theme}) => ({
//   display: 'flex',
//   gap: theme.spacing(1),
//   marginTop: theme.spacing(1.5),
// }))

// const StaySignedInButton = styled(Button)(({theme}) => ({
//   backgroundColor: theme.palette.warning.dark,
//   color: '#fff',
//   fontWeight: 600,
//   '&:hover': {
//     backgroundColor: theme.palette.warning.main,
//   },
// }))

// const DismissButton = styled(Button)(({theme}) => ({
//   color: theme.palette.warning.dark,
//   borderColor: theme.palette.warning.dark,
//   '&:hover': {
//     borderColor: theme.palette.warning.main,
//     backgroundColor: 'rgba(237, 108, 2, 0.08)',
//   },
// }))

/**
 * Session timeout warning notification component.
 *
 * Displays a bottom-left notification when the session is about to expire.
 * User can dismiss with X button. Auto-logout occurs when token expires.
 */
export function SessionWarningNotification() {
  const {showWarning, minutesRemaining, dismissWarning} = useSessionTimeout()

  const handleDismiss = () => {
    dismissWarning()
  }

  return (
    <Snackbar
      open={showWarning}
      anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
      // Don't auto-hide - user must interact
      autoHideDuration={null}
      sx={{
        // Ensure it's above other elements but below modals
        zIndex: 1400,
      }}>
      <StyledAlert
        severity="warning"
        variant="filled"
        icon={<Clock size={24} />}
        action={
          <Button
            aria-label="close"
            color="inherit"
            size="small"
            onClick={handleDismiss}
            sx={{minWidth: 'auto', p: 0.5}}>
            <X size={18} />
          </Button>
        }>
        <MessageContainer>
          <TitleRow>
            <Typography variant="subtitle1" fontWeight={600}>
              Session Expiring Soon
            </Typography>
          </TitleRow>

          <Typography variant="body2">
            Your session will expire in{' '}
            <strong>
              {minutesRemaining} minute{minutesRemaining !== 1 ? 's' : ''}
            </strong>{' '}
            due to inactivity.
          </Typography>

          <Typography variant="body2" sx={{opacity: 0.9}}>
            Please save your work to avoid losing changes.
          </Typography>

          {/* TODO: Re-enable when BE refresh endpoint is available
          <ActionContainer>
            <StaySignedInButton variant="contained" size="small" onClick={handleStaySignedIn}>
              Stay signed in
            </StaySignedInButton>
            <DismissButton variant="outlined" size="small" onClick={handleDismiss}>
              Dismiss
            </DismissButton>
          </ActionContainer>
          */}
        </MessageContainer>
      </StyledAlert>
    </Snackbar>
  )
}

export default SessionWarningNotification
